<script>
  import { onMount } from 'svelte';

  import { APIS, INDEX_PARAMS } from '$lib/utils/consts';
  import { Request, successResp, errorResp } from '$lib/utils/_api';
  import { formatDate } from '$lib/utils/date-format';

  let reportList = [];

  onMount(async () => {
    try {
      const resp = await Request.get(APIS.report, { params: INDEX_PARAMS });

      successResp(resp, (data) => {
        // console.log(data);
        reportList = data.list || [];
      });
    } catch(err) {
      console.log(err);
    }
  });

  let reportFirst;
  $: {
    if (reportList.length > 0) {
      reportFirst = reportList.shift();
    }
  }

  // const reportList = [{
  //   title: '白溪视角｜价值股与成长股的新思考 · 外围环境引发避险需求 · 市场没有方向，多杀多的局面',
  //   date: '2022-02-28',
  //   content: ''
  // }, {
  //   title: '白溪视角 | 资金充裕:并没有监测到大幅赎回的情况并没有监测到大幅赎回的情况并没有监测到大幅赎回的情况并没有监测到大幅赎回的情况并没有监测到大幅赎回的情况并没有监测到大幅赎回的情况并没有监测到大幅赎回的情况并没有监测到大幅赎回的情况并没有监测到大幅赎回的情况并没有监测到大幅赎回的情况并没有监测到大幅赎回的情况并没有监测到大幅赎回的情况',
  //   date: '2022-02-28'
  // }, {
  //   title: '白溪视角 | 资金充裕:并没有监测到大幅赎回的情况',
  //   date: '2022-02-28'
  // }, {
  //   title: '白溪视角 | 资金充裕:并没有监测到大幅赎回的情况',
  //   date: '2022-02-28'
  // }]
</script>

<div class="my-12">
  <h2 class="text-2xl font-medium text-orange-500 mb-6">每周观评</h2>
  {#if reportFirst}
    <div>
      <h1 class="text-xl sm:text-3xl font-bold my-2">
        <a href="/detail/report/{reportFirst.newsId}" class="hover:text-orange-500">{reportFirst.title}</a>
      </h1>
      <p class="text-gray-400 text-sm">{reportFirst.publishAt ? formatDate(reportFirst.publishAt) : formatDate(reportFirst.updatedAt)}</p>
      <p class="my-6 ml-4 leading-8 text-gray-500">{reportFirst.content}</p>
    </div>
    <ul>
      {#each reportList as report}
        <li class="flex flex-col sm:flex-row sm:justify-between py-4 border-t border-t-gray-300">
          <a href="/detail/report/{report.newsId}" class="hover:text-orange-500">{report.title}</a>
          <span class="whitespace-nowrap text-gray-400">{report.publishAt ? formatDate(report.publishAt) : formatDate(report.updatedAt)}</span>
        </li>
      {/each}
    </ul>
  {/if}
  <p>
    <a class="text-orange-500 hover:text-orange-400" href="/research/report">更多……</a>
  </p>
</div>
